import styled from 'styled-components';

const FormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export default FormContainer;
